import React from 'react';
import SarasTrans from '../../../../library/notifications/SarasTrans';

const DashSCRow = (props) => {
    const { viewData } = props;


    return (
        <div className="uiDashShortcutMenuRow">
            <span><SarasTrans value={viewData.valF} /></span>
        </div>
    )
}

export default DashSCRow;
